<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-filtration"
  [title]="'dashboard.filtration' | translate"
  [content]="buttons[this.actionStack!.getValue('fsCModeFonctionnement')].icon!"
  [color]="buttons[this.actionStack!.getValue('fsCModeFonctionnement')].color!"
  [status]="
    buttons[this.actionStack!.getValue('fsSCommandePompe')].title! | translate
  "
  [mode]="
    P0003600ProgrammeFiltrationAuto[
      this.actionStack!.getValue('fsCProgrammeFiltrationAuto')
    ].value
  "
  [statusMode]="buttons[this.actionStack!.getValue('fsSCommandePompe')].status!"
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
